export function isValidReadAlso({ attributes: { items = [] } }: TContent) {
  return !!items.length;
}
